import React, { useEffect, useState } from "react";
import Close from "../../../../../Icons/Close";
import ModalOk from "../../../../../components/compte/ModalMdpOk";
import { useForm } from "react-hook-form";
import Classnames from "classnames";
import srcIconCheck from "../../../../../styles/img/icon-check-white.svg";
import Img from "react-image";
import jwt_decode from "jwt-decode";
import { styles } from "../../../../../ReactConst";
import { StyleRoot } from "radium";
import _ from "lodash";
import { useTranslation } from 'react-i18next';

const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;

export default function ModalAjoutStaff(props) {
  const { t } = useTranslation();
  const [styleFadeIn, setFadeIn] = useState(true);
  const [isOpenAdminAdd, setAdminAdd] = useState(false);
  const [buttonValid, setButtonValid] = useState(false);
  const [valuesForm, setValuesForm] = useState({
    prenom: "",
    nom: "",
    email: "",
    numeroTel: "",
    typeCompte: "",
    fonction: "",
    email: "",
  });
  useEffect(() => {
    if (
      !_.isEmpty(valuesForm.prenom) &&
      !_.isEmpty(valuesForm.nom) &&
      !_.isEmpty(valuesForm.email) &&
      !_.isEmpty(valuesForm.numeroTel) &&
      !_.isEmpty(valuesForm.typeCompte) &&
      !_.isEmpty(valuesForm.fonction)
    ) {
      setButtonValid(true);
    } else {
      setButtonValid(false);
    }
  }, [valuesForm]);

  const { handleSubmit, register, errors, setValue } = useForm();
  const onSubmit = (values) => {
    let token = localStorage.getItem("token");
    let tokenDecoded = token ? jwt_decode(token) : "";
    if (values.typeCompte === "ADMIN_CRECHE") {
      let data = {
        ...values,
        compteAgent: {
          typeCompte: values.typeCompte,
          identifiant: values.email,
        },
      };
      delete data.typeCompte;
      setValuesForm(data);
      setAdminAdd(true);
    } else {
      let data = {
        ...values,
        compteAgent: {
          typeCompte: values.typeCompte,
          identifiant: values.email,
        },
      };
      delete data.typeCompte;
      props.submitAjoutStaff(data);
    }
  };
  const handleChange = (e) => {
    setValue(e.target.name, e.target.value);
    setValuesForm({ ...valuesForm, [e.target.name]: e.target.value });
  };
  const onSubmitAdmin = () => {
    props.submitAjoutStaff(valuesForm);
  };

  const ConfirmationReset = React.useCallback(() => {
    setFadeIn(false);
    setTimeout(() => {
      setAdminAdd(false);
    }, 400);
  }, []);

  const closeModal = React.useCallback(() => {
    setAdminAdd(false);
    setFadeIn(false);
    setTimeout(() => {
      props.onClose();
    }, 400);
  }, []);

  return (
    <StyleRoot>
      <div
        style={styleFadeIn === true ? styles.bounce : styles.bounce2}
        className="modal fade modal-skin modalAddStaff show"
        id="modalAddStaff"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modalAddStaff"
        aria-hidden="true"
      >
        {isOpenAdminAdd ? (
          <ModalOk
            title={t('staff_modal.add_member')}
            message={
              t('staff_modal.admin_confirm')
            }
            closeModal={ConfirmationReset}
            handleSubmit={onSubmitAdmin}
          />
        ) : (
          ""
        )}
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit(onSubmit)}>
              <button
                onClick={props.onClose}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close className="img-fluid" alt="" />{" "}
              </button>
              <div className="modal-body">
                <h5 className="modal-title mt-0">{t('staff_modal.new_member')}</h5>
                <section className="content-section pt-3 pb-0 mb-0 border-0">
                  <div className="row">
                    <div className="col-md-6 pl-2">
                      <div
                        className={Classnames("form-group", {
                          "error-mess": errors.prenom,
                        })}
                      >
                        <input
                          onChange={handleChange}
                          type="text"
                          className="form-control box-shadow custom-input ipt-id-nom"
                          name="prenom"
                          ref={register({
                            required: t('validation.field_required'),
                          })}
                          placeholder={t('staff_modal.firstname')}
                        />
                        {errors.prenom && errors.prenom.message && (
                          <p>{errors.prenom.message}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 pr-2">
                      <div
                        className={Classnames("form-group", {
                          "error-mess": errors.nom,
                        })}
                      >
                        <input
                          onChange={handleChange}
                          type="text"
                          className="form-control box-shadow custom-input ipt-id-nom"
                          name="nom"
                          ref={register({
                            required: t('validation.field_required'),
                          })}
                          placeholder={t('staff_modal.lastname')}
                        />
                        {errors.nom && errors.nom.message && (
                          <p>{errors.nom.message}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div
                        className={Classnames("form-group", {
                          "error-mess": errors.email,
                        })}
                      >
                        <input
                          onChange={handleChange}
                          type="text"
                          className="form-control box-shadow custom-input ipt-id-email"
                          name="email"
                          ref={register({
                            required: t('validation.field_required'),
                            pattern: {
                              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                              message: t('validation.email_invalid'),
                            },
                          })}
                          placeholder={t('staff_modal.email')}
                        />
                        {errors.email && errors.email.message && (
                          <p>{errors.email.message}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div
                        className={Classnames("form-group", {
                          "error-mess": errors.numeroTel,
                        })}
                      >
                        <input
                          onChange={handleChange}
                          type="text"
                          className="form-control box-shadow custom-input ipt-id-tel"
                          name="numeroTel"
                          ref={register({
                            required: t('validation.field_required'),
                            pattern: {
                              value: /^(\+?)\d{7,}/i,
                              message: t('validation.phone_invalid'),
                            },
                          })}
                          placeholder={t('staff_modal.phone')}
                        />
                        {errors.numeroTel && errors.numeroTel.message && (
                          <p>{errors.numeroTel.message}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div
                        className={Classnames("form-group", {
                          "error-mess": errors.typeCompte,
                        })}
                      >
                        <select
                          onChange={handleChange}
                          className="form-control box-shadow custom-select ipt-id-compte"
                          name="typeCompte"
                          ref={register({
                            required: t('validation.field_required'),
                          })}
                        >
                          <option value="">
                            {t('staff_modal.select_account_type')}
                          </option>
                          <option value="ADMIN_CRECHE">{t('staff_modal.admin')}</option>
                          <option value="AGENT_CRECHE_CONFIRME">
                            {t('staff_modal.advanced_user')}
                          </option>
                          <option value="AGENT_CRECHE_NON_CONFIRME">
                            {t('staff_modal.user')}
                          </option>
                        </select>
                        {errors.typeCompte && errors.typeCompte.message && (
                          <p>{errors.typeCompte.message}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div
                        className={Classnames("form-group", {
                          "error-mess": errors.fonction,
                        })}
                      >
                        <select
                          onChange={handleChange}
                          className="form-control box-shadow custom-select ipt-id-fonction"
                          name="fonction"
                          ref={register({
                            required: t('validation.field_required'),
                          })}
                        >
                          <option value="">{t('staff_modal.choose_function')}</option>
                          <option value="DIRECTRICE">{t('staff_modal.function_director')}</option>
                          <option value="PUERCULTIRCE">
                            {t('staff_modal.function_auxiliaire')}
                          </option>
                          <option value="EDUCATRICE">{t('staff_modal.function_educateur')}</option>
                          <option value="INFERMIERE">{t('staff_modal.function_infirmiere')}</option>
                          <option value="AUXILIAIRE_PUERICULTURE">
                            {t('staff_modal.function_cap')}
                          </option>
                          <option value="CUISINERE">{t('staff_modal.function_cuisinier')}</option>
                          <option value="ENTRETIEN">{t('staff_modal.function_agent')}</option>
                          <option value="AUTRE">{t('staff_modal.function_autre')}</option>
                        </select>
                        {errors.fonction && errors.fonction.message && (
                          <p>{errors.fonction.message}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
                <div className="d-flex justify-content-center mt-3">
                  <button
                    style={buttonValid ? { opacity: 1 } : { opacity: 0.25 }}
                    type="submit"
                    className="btn-gradient btn-valid"
                  >
                    <IconCheckWhite /> {t('common.validate')}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </StyleRoot>
  );
}
